import { useNavigate } from "react-router-dom";
import { Trash2, Mail, ArrowLeft } from "lucide-react";

function ExclusaoDeDados() {
	const navigate = useNavigate();

	return (
		<div className="min-h-screen flex flex-col font-sans bg-gray-50 antialiased">
			{/* Navbar */}
			<header className="w-full bg-white shadow-sm sticky top-0 z-50">
				<div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between">
					<div
						className="flex-shrink-0 flex items-center gap-2 cursor-pointer group"
						onClick={() => navigate("/home")}
					>
						<div className="bg-gradient-to-br from-blue-600 to-blue-900 text-white w-9 h-9 rounded-xl shadow-[0_4px_10px_-2px_rgba(37,99,235,0.4)] flex items-center justify-center transform transition-all group-hover:scale-105 group-hover:-translate-y-0.5 relative z-10 overflow-hidden">
							<span className="font-extrabold text-xl leading-none tracking-tight translate-z-0 drop-shadow-sm px-1 mt-0.5">
								SZ
							</span>
						</div>
						<div className="hidden sm:flex flex-col justify-center antialiased">
							<span className="font-black text-xl leading-none text-gray-900 tracking-tight">
								Sistemas
							</span>
							<span className="text-[10px] font-bold text-blue-600 tracking-widest uppercase leading-none mt-1">
								Gestão Inteligente
							</span>
						</div>
					</div>

					<button
						onClick={() => navigate("/home")}
						className="flex items-center gap-2 text-gray-600 hover:text-blue-600 font-medium transition-colors text-sm"
					>
						<ArrowLeft size={16} />
						Voltar ao site
					</button>
				</div>
			</header>

			{/* Hero */}
			<section className="bg-gradient-to-b from-blue-900 to-blue-800 text-white py-16">
				<div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
					<div className="inline-flex items-center justify-center w-16 h-16 bg-blue-800/50 border border-blue-400/30 rounded-full mb-6">
						<Trash2 size={28} />
					</div>
					<h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight mb-3">
						Exclusão de Dados do Usuário — Sz_Automação
					</h1>
				</div>
			</section>

			{/* Conteúdo */}
			<main className="flex-1 py-16">
				<div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
					<div className="bg-white border border-gray-100 rounded-2xl shadow-sm p-8 sm:p-10 space-y-6">
						<p className="text-gray-600 leading-relaxed">
							Para solicitar a exclusão dos seus dados coletados pelo{" "}
							<strong className="text-gray-900">Sz_Automação</strong>, envie um e-mail para{" "}
							<a
								href="mailto:suporte@szsistemas.com.br?subject=Exclus%C3%A3o%20de%20Dados"
								className="text-blue-600 font-semibold hover:underline"
							>
								suporte@szsistemas.com.br
							</a>{" "}
							com o assunto <strong className="text-gray-900">"Exclusão de Dados"</strong> informando seu
							nome e e-mail cadastrado.
						</p>

						<p className="text-gray-600 leading-relaxed">
							Seus dados serão removidos em até <strong className="text-gray-900">15 dias úteis</strong>.
							Você receberá uma confirmação por e-mail assim que a exclusão for concluída.
						</p>

						<div className="border-t border-gray-100 pt-6 flex items-center gap-3">
							<div className="w-10 h-10 shrink-0 bg-blue-100 text-blue-700 rounded-lg flex items-center justify-center">
								<Mail size={20} />
							</div>
							<p className="text-gray-600">
								Dúvidas:{" "}
								<a
									href="mailto:suporte@szsistemas.com.br"
									className="text-blue-600 font-semibold hover:underline"
								>
									suporte@szsistemas.com.br
								</a>
							</p>
						</div>
					</div>
				</div>
			</main>

			{/* Rodapé */}
			<footer className="bg-gray-900 text-gray-400 py-8 border-t-4 border-blue-600">
				<div className="max-w-5xl mx-auto px-6 text-center text-sm">
					<p>© {new Date().getFullYear()} - SZ Sistemas. Todos os direitos reservados.</p>
				</div>
			</footer>
		</div>
	);
}

export default ExclusaoDeDados;
